export const HTTPStatusCodes = Object.freeze({
	BAD_REQUEST: 400,
	CONFLICT: 409,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	UNAUTHORIZED: 401
});
